<sf-loader></sf-loader>
<sf-notification></sf-notification>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="formgrid grid">
    <div class="col-12 sm:col-12 md:col-12 lg:col-6">
        <sf-sub-header [title]="isMyData == true ? ('label.myPersonalData' | translate) : ('title.user_control' | translate)"
            [description]="isMyData == true ? ('label.MyPersonalDataDescription' | translate) : ('label.profile' | translate)">
        </sf-sub-header>
    </div>
    <div class="col-12 sm:col-12 md:col-12 lg:col-6">
        <sf-breadcrumb [model]="BREAD_CRUMB_LIST"></sf-breadcrumb>
    </div>
</div>

<p-divider></p-divider>

<section class="flex flex-column">
    <div class="flex flex-column flex-auto">
        <div class="surface-section px-4 py-4 lg:py-5 lg:px-6 h-full border-round-top-xl">

            <div class="p-fluid flex flex-column lg:flex-row">
                <ul
                    class="list-none m-0 p-0 flex flex-row lg:flex-column justify-content-between lg:justify-content-start mb-5 lg:mb-0">
                    <li>
                        <a pRipple
                            class="lg:w-15rem flex align-items-center cursor-pointer p-3 border-round hover:surface-200 transition-duration-150 transition-colors"
                            [ngClass]="{'surface-200': activeTab === 0}" (click)="activeTab = 0">
                            <i class="pi pi-user md:mr-2" style="font-size: 1.5rem"
                                [ngClass]="{'text-700' : activeTab === 0, 'text-600': activeTab !== 0}"></i>
                            <span class="font-medium hidden md:block text-xl"
                                [ngClass]="{'text-800': activeTab === 0, 'text-700': activeTab !== 0}">Usuário</span>
                        </a>
                    </li>
                    <li>
                        <a pRipple
                            class="lg:w-15rem flex align-items-center cursor-pointer p-3 border-round hover:surface-200 transition-duration-150 transition-colors"
                            [ngClass]="{'surface-200': activeTab === 1}" (click)="active(1)">
                            <i class="pi pi-users md:mr-2" style="font-size: 1.5rem"
                                [ngClass]="{'text-700' : activeTab === 1, 'text-600': activeTab !== 1}"></i>
                            <span class="font-medium hidden md:block text-xl"
                                [ngClass]="{'text-800': activeTab === 1, 'text-700': activeTab !== 1}">Dados
                                Pessoais</span>
                        </a>
                    </li>
                    <li>
                        <a pRipple
                            class="lg:w-15rem flex align-items-center cursor-pointer p-3 border-round hover:surface-200 transition-duration-150 transition-colors"
                            [ngClass]="{'surface-200': activeTab === 2}" (click)="activeTab = 2">
                            <i class="pi pi-bell md:mr-2" style="font-size: 1.5rem"
                                [ngClass]="{'text-700' : activeTab === 2, 'text-600': activeTab !== 2}"></i>
                            <span class="font-medium hidden md:block text-xl"
                                [ngClass]="{'text-800': activeTab === 2, 'text-700': activeTab !== 2}">Notificações</span>
                        </a>
                    </li>
                    <li>
                        <a pRipple
                            class="lg:w-15rem flex align-items-center cursor-pointer p-3 border-round hover:surface-200 transition-duration-150 transition-colors"
                            [ngClass]="{'surface-200': activeTab === 3}" (click)="activeTab = 3">
                            <i class="pi pi-list md:mr-2" style="font-size: 1.5rem"
                                [ngClass]="{'text-700' : activeTab === 3, 'text-600': activeTab !== 3}"></i>
                            <span class="font-medium hidden md:block text-xl"
                                [ngClass]="{'text-800': activeTab === 3, 'text-700': activeTab !== 3}">Logs de
                                Acesso</span>
                        </a>
                    </li>


                </ul>
                <div class="surface-card p-5 shadow-2 border-round flex-auto xl:ml-5">




                    <!-- <div *ngIf="activeTab==0"> -->
                    <div [style]="activeTab==0 ? {'display': 'block'} : {'display': 'none'}">
                        <div class="text-900 font-semibold mt-3 text-xl"><span translate>label.user_data</span></div>
                        <p-divider></p-divider>
                        <div class="flex gap-5 flex-column-reverse responsive-user-profile">
                            <div class="flex-auto p-fluid">
                                <sc-user-detail [id]="userId"></sc-user-detail>
                            </div>
                            <div class="flex flex-column align-items-center flex-or">

                                <span class="font-normal text-900 mb-2 text-xl" translate>label.picture</span>




                                <div class="p-field center-img flex align-items-center justify-content-center">
                                    <div class="avatar-container">
                                        <div class="image-container"
                                            [ngStyle]="{backgroundImage: 'url(' + item.pictureUri+ ')'}"
                                            *ngIf="hasPicture"></div>
                                        <div class="image-container"
                                            [ngStyle]="{backgroundImage: 'url(assets/layout/images/perfil.svg)'}"
                                            *ngIf="!hasPicture"></div>
                                        <button pButton type="button" icon="pi pi-pencil" class="p-button-rounded -mt-4"
                                            (click)="showPicDialog()"></button>
                                        <!-- <label for="avatar-input-file">
                                            <div class="icon-wrapper">
                                                <input type="file" id="avatar-input-file" (change)="fileChangeEvent($event)" accept="image/*"/>
                                                <i class="pi pi-upload icon"></i>
                                            </div>
                                        </label> -->
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>


                    <div *ngIf="activeTab==1">
                        <div class="text-900 font-semibold mt-3 text-xl"><span translate>label.myPersonalData</span>
                        </div>
                        <p-divider></p-divider>
                        <div class="flex gap-5 flex-column-reverse md:flex-row">
                            <div class="flex-auto p-fluid">
                                <sc-person-full-client [id]="item.scPerson.id"></sc-person-full-client>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="activeTab==2">
                        <div class="text-900 font-semibold mt-3 text-xl"><span translate>label.notification</span>
                        </div>
                        <p-divider></p-divider>
                        <div class="flex gap-5 flex-column-reverse md:flex-row">
                            <div class="flex-auto p-fluid">
                                <p-card>
                                    <div class="col-12">

                                        <!-- <div class="grid mt-3">
                                                                    <div class="col-5 text-center font-bold label-detail text-xl"><span translate>label.status</span></div>
                                                                    <div class="col ml-1 text-xl">
                                                                        <span [style]="{'color':''+item.scUserStatusColor+''}">{{item.scUserStatusName}}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="grid mt-3">
                                                                    <div class="col-5 text-center font-bold label-detail text-xl"><span translate>label.createdAt</span></div>
                                                                    <div class="col ml-1 text-xl">{{item.createdAt |  date:'dd/MM/yyyy HH:mm:ss'}}</div>
                                                                 </div>
                                                                <div class="grid mt-3">
                                                                    <div class="col-5 text-center font-bold label-detail text-xl"><span translate>label.updatedAt</span></div>
                                                                    <div class="col ml-1 text-xl">{{item.updatedAt |  date:'dd/MM/yyyy HH:mm:ss'}}</div>
                                                                </div>
                                                                <div class="grid mt-3 mb-2">
                                                                    <div class="col-5 text-center font-bold label-detail text-xl"><span translate>label.login_last_date</span></div>
                                                                    <div class="col ml-1 text-xl">{{item.createdAt |  date:'dd/MM/yyyy HH:mm:ss'}}</div>
                                                                </div> -->
                                        <div class="formgrid grid text-lg ">
                                            <div class="dashboard col-12 md:col-12 lg:col-12 xl:col-12 mt-2">

                                                <p-card styleClass="chat" header="Menssagens e Notificações">
                                                    <p-scrollPanel
                                                        [style]="{ width: '100%', height: screenHeightChat }">
                                                        <ng-container *ngFor="let chat of chatList; let i = index">
                                                            <ul>
                                                                <div *ngIf="chat.sourceUserId != userId">
                                                                    <li class="message-from">
                                                                        <div class="message-meta">
                                                                            <p-avatar
                                                                                [label]="getInitials(chat.sourceUserName)"
                                                                                [style]="{ 'background-color': AVATAR_COLOR_FROM, 'color': 'white', 'font-weight': 'bold' }"></p-avatar>
                                                                            <span
                                                                                class="name ml-2">{{chat.sourceUserName}}</span>
                                                                            <span class="time">{{chat.dateOfRegistration
                                                                                | date: 'dd/MM/yyyy
                                                                                HH:mm'}}</span>
                                                                        </div>
                                                                        <div class="message">
                                                                            <span><label
                                                                                    [innerHtml]="chat.message"></label></span>
                                                                        </div>
                                                                    </li>
                                                                </div>
                                                                <div *ngIf="chat.sourceUserId == userId">
                                                                    <li class="message-own">
                                                                        <div class="message">
                                                                            <span><label
                                                                                    [innerHtml]="chat.message"></label></span>
                                                                        </div>
                                                                        <div class="message-meta">
                                                                            <p-avatar
                                                                                [label]="getInitials(chat.sourceUserName)"
                                                                                [style]="{ 'background-color': AVATAR_COLOR_OWN, 'color': 'white', 'font-weight': 'bold' }"></p-avatar>
                                                                            <span
                                                                                class="name ml-2">{{chat.sourceUserName}}</span>
                                                                            <span class="time">{{chat.dateOfRegistration
                                                                                | date: 'dd/MM/yyyy
                                                                                HH:mm'}}</span>
                                                                        </div>
                                                                    </li>
                                                                </div>

                                                            </ul>
                                                        </ng-container>
                                                    </p-scrollPanel>
                                                    <div class="write-message">
                                                        <i class="pi pi-paperclip"></i>
                                                        <input type="text" />
                                                    </div>
                                                </p-card>
                                            </div>
                                        </div>
                                    </div>
                                </p-card>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="activeTab==3">
                        <div class="text-900 font-semibold mt-3 text-xl"><span translate>label.access_logs</span></div>
                        <p-divider></p-divider>
                        <div class="flex gap-5 flex-column-reverse md:flex-row">
                            <div class="flex-auto p-fluid">
                                <p-card>
                                    <div class="col-12">

                                        <div class="grid mt-3">
                                            <div class="col-5 text-center font-bold label-detail text-xl"><span
                                                    translate>label.status</span></div>
                                            <div class="col ml-1 text-xl">
                                                <span
                                                    [style]="{'color':''+item.scUserStatusColor+''}">{{item.scUserStatusName}}</span>
                                            </div>
                                        </div>
                                        <div class="grid mt-3">
                                            <div class="col-5 text-center font-bold label-detail text-xl"><span
                                                    translate>label.createdAt</span></div>
                                            <div class="col ml-1 text-xl">{{item.createdAt | date:'dd/MM/yyyy
                                                HH:mm:ss'}}</div>
                                        </div>
                                        <div class="grid mt-3">
                                            <div class="col-5 text-center font-bold label-detail text-xl"><span
                                                    translate>label.updatedAt</span></div>
                                            <div class="col ml-1 text-xl">{{item.updatedAt | date:'dd/MM/yyyy
                                                HH:mm:ss'}}</div>
                                        </div>
                                        <div class="grid mt-3 mb-2">
                                            <div class="col-5 text-center font-bold label-detail text-xl"><span
                                                    translate>label.login_last_date</span></div>
                                            <div class="col ml-1 text-xl">{{item.createdAt | date:'dd/MM/yyyy
                                                HH:mm:ss'}}</div>
                                        </div>
                                    </div>
                                </p-card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid mt-3">
                <div class="col">
                    <div class="text-right">
                        <button pButton pRipple icon="pi pi-times" style="width: 150px; margin: 3px;"
                            class="text-xl font-semibold p-button-outlined" size="large"
                            [label]="'button.cancel' | translate" (click)="cancel();">
                        </button>
                        <button pButton pRipple icon="pi pi-save" style="width: 150px; margin: 3px;" class="text-xl font-semibold ml-3"
                            [label]="'button.save' | translate" (click)="save();" [disabled]="isUserFormValid">
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<p-dialog [(visible)]="userPicDialog" [style]="{width: '500px',height: '500px'}"
    [header]="'label.user_upload_avatar' | translate" [modal]="true" styleClass="p-fluid">
    <ng-template pTemplate="content">
        <div style="margin-top:1px;" class="grid">
            <div class="col-12 p-field flex align-items-center justify-content-center font-bold" style="width: 100%;">
                <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true"
                    [containWithinAspectRatio]="containWithinAspectRatio" [aspectRatio]="1" [resizeToWidth]="128"
                    [cropperMinWidth]="128" [roundCropper]="true" [canvasRotation]="canvasRotation"
                    [alignImage]="'center'" [style.display]="showCropper ? null : 'none'" format="png"
                    (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()"
                    (cropperReady)="cropperReady($event)" (loadImageFailed)="loadImageFailed()">
                </image-cropper>

                <div class="flex align-items-center justify-content-center" *ngIf="showCropper">
                    <img [src]="croppedImage" />
                </div>

                <div class="flex align-items-center justify-content-center" *ngIf="!showCropper">
                    <div class="image-container" [ngStyle]="{backgroundImage: 'url(' + item.pictureUri+ ')'}"
                        *ngIf="hasPicture"></div>
                    <div class="image-container" [ngStyle]="{backgroundImage: 'url(assets/layout/images/perfil.svg)'}"
                        *ngIf="!hasPicture && isLoaded"></div>
                </div>
            </div>
            <div class="w-full text-2xl font-semibold p-button-info flex align-items-center justify-content-center">
                <label for="avatar-input-file">
                    <div class="button-wrapper">
                        <span translate class="ml-2">label.selectPicture</span>
                        <input type="file" id="avatar-input-file" (change)="fileChangeEvent($event)" accept="image/*" />
                    </div>
                </label>
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="footer">
        <div class="flex justify-content-end">

            <button pButton pRipple icon="pi pi-times" style="width: 150px; margin-right: 10px;"
                class="text-xl font-semibold p-button-outlined" size="large" [label]="'button.cancel' | translate"
                (click)="hidePicDialog();">
            </button>

            <div *ngIf="showCropper">
                <button pButton pRipple icon="pi pi-save" style="width: 150px;" class="text-xl font-semibold"
                    [label]="'button.save' | translate" (click)="savePic();" [disabled]="!showCropper">
                </button>
            </div>
        </div>
    </ng-template>
</p-dialog>
